import { render, staticRenderFns } from "./ReminderSettings.vue?vue&type=template&id=3fb182fc"
import script from "./ReminderSettings.vue?vue&type=script&lang=js"
export * from "./ReminderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports